// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2GFlc","cell":"ColumnAccessor_cell__ML4NB","firstCellAccent":"ColumnAccessor_firstCellAccent__dh9h5"};